import React, {useContext} from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { Titre, Texte } from "../../utils/style/elements.tsx";

import crowsEulogyData from "../../datas/crowsEulogyData.js";
import npsData from "../../datas/npsData.js";
import ebwData from "../../datas/ebwData.js";
import tothepeakData from "../../datas/tothepeakData";
import chaumiereData from "../../datas/chaumiereData.js";
//import semaphoreData from "../../datas/semaphoreData";
//import scimitarData from "../../datas/scimitarData";
import jackpotData from "../../datas/jackpotData";
import serpicoData from "../../datas/serpicoData.js";
import azuraData from "../../datas/azuraData.js";
import psxData from "../../datas/psxData.js";
import wizgemsData from "../../datas/wizgemsData.js";
import gamebuinoData from "../../datas/gamebuinoData.js";
import monoDungeonData from "../../datas/monoDungeonData.js";
import openglData from "../../datas/openglData.js";
import noreyaData from "../../datas/noreyaData.js";
import lockedData from "../../datas/lockedData.js";
import jsnapData from "../../datas/jsnapData.js";
import batcaveData from "../../datas/batcaveData.js";

import colors from "../../utils/style/colors.tsx";
import { LanguageContext } from "../../context/LanguageContext";

import BackButtton from "../../components/BackButton/BackButton.jsx";

const PageContainer = styled.div``;

const SectionTitle = styled.div``;

const SectionTitleOnly = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: -70px;
`;

const SectionContent = styled.div`
    display: flex;
    gap: 130px;

    @media (max-width: 900px) {
        flex-direction: column;
        gap: 20px;
    }
`;

const ImgTitreContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`;

const ImgTitre = styled.img`
    width: 520px;
    height: 415px;

    @media (max-width: 768px) {
        width: 265px;
        height: 215px;
    }
`;

const LargeTextContainer = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
`;

const TextContainer = styled.div`
    display: flex;
    width: 50%;
    align-items: start;

    @media (max-width: 900px) {
        width: 100%;
    }
`;

const StyledTexte = styled(Texte)`
    width: 100%;
    margin: 0;

    @media (max-width: 1150px) {
        font-size: 20px;
    }
`;

const ProjectImgContainer = styled.div`
    width: 50%;
    display: flex;
    align-items: center;

    @media (max-width: 900px) {
        width: 100%;
        justify-content: center;
    }
`;

const ProjectImage = styled.img`
    width: 100%;
    object-fit: contain;

    @media (max-width: 900px) {
        width: 80%;
    }
`;

const VideoContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;

    iframe {
        @media (max-width: 768px) {
            width: 100%;
            height: 200px;
        }
    }
`;

const Section = styled.div`
    margin-bottom: 70px;

    @media (max-width: 900px) {
        margin-bottom: 30px;
    }
`;

const LinkContainer = styled.div`
    width: 100%;
    display: flex;
    color: ${colors.red};
`;

const LinkUl = styled.ul`
    @media (max-width: 1150px) {
        padding-left: 20px;
    }
`;

const LinkLi = styled.li`
    margin-bottom: 20px;
`;

const LinkLien = styled.a`
    color: ${colors.red};
    text-decoration: none;
    font-size: 24px;
    word-break: break-all;

    &:hover {
        border-bottom: solid 2px ${colors.red};
    }

    @media (max-width: 1150px) {
        font-size: 20px;
    }

    @media (max-width: 768px) {
        font-size: 16px;
    }
`;

const projectDatas = {
    "crows-eulogy": crowsEulogyData,
    "news-paper-scissors": npsData,
    "every-breaking-wave": ebwData,
    "to-the-peak": tothepeakData,
    "chaumiere": chaumiereData,
    //"semaphore": semaphoreData,
    //"scimitar": scimitarData,
    "jackpot": jackpotData,
    "serpico": serpicoData,
    "azura": azuraData,
    "psx": psxData,
    "wizgems": wizgemsData,
    "gamebuino": gamebuinoData,
    "mono-dungeon": monoDungeonData,
    "ogl": openglData,
    "noreya": noreyaData,
    "locked": lockedData,
    "jsnap": jsnapData,
    "batcave": batcaveData,
};

const ErrorContainer = styled.div`
    min-height: 52vh;
`;

function ProjectPage() {
    const { slug } = useParams();
    const project = projectDatas[slug];

    const { language } = useContext(LanguageContext);
    
    if (!project) {
        return (
            <ErrorContainer>
                <h1>Oups 🗿 Cette page n'existe pas</h1>
            </ErrorContainer>
        );
    }

    return (
        <PageContainer>
            {project.sections.map((section, index) => {
                // Sélection dynamique selon la langue
                const titleElement = section.elements.find(
                    (element) => element.type === `${language}-title`
                );
                const imgTitleElement = section.elements.find(
                    (element) => element.type === "imageTitle"
                );
                const textElements = section.elements.filter(
                    (element) => element.type === `${language}-text`
                );
                const contentElements = section.elements.filter(
                    (element) =>
                        element.type !== `${language}-title` &&
                        element.type !== "imageTitle"
                );

                const hasMedia = section.elements.some(
                    (element) =>
                        element.type === "image" ||
                        element.type === "video" ||
                        element.type === "link"
                );

                return (
                    <Section key={index}>
                        {/* Titre principal */}
                         {titleElement && (
                            section.elements.length === 2 ? (
                                <SectionTitleOnly>
                                    <Titre>{titleElement.content}</Titre>
                                </SectionTitleOnly>
                            ) : (
                                // Sinon affichage classique
                                <SectionTitle>
                                    <Titre>{titleElement.content}</Titre>
                                    {index === 0 && imgTitleElement && (
                                        <ImgTitreContainer>
                                            <ImgTitre
                                                src={imgTitleElement.src}
                                                alt={imgTitleElement.alt}
                                            />
                                        </ImgTitreContainer>
                                    )}
                                </SectionTitle>
                            )
                        )}

                        {/* Texte large uniquement si la section ne contient que du texte */}
                        {textElements.length > 0 && !hasMedia && (
                            <LargeTextContainer>
                                {textElements.map((text, idx) => (
                                    <StyledTexte key={idx}>
                                        {text.content}
                                    </StyledTexte>
                                ))}
                            </LargeTextContainer>
                        )}

                        {/* Gestion des liens */}
                        {contentElements.some(
                            (element) => element.type === "link"
                        ) && (
                            <LinkContainer>
                                <LinkUl>
                                    {contentElements
                                        .filter(
                                            (element) => element.type === "link"
                                        )
                                        .map((element, idx) => (
                                            <LinkLi key={idx}>
                                                <LinkLien
                                                    href={element.content}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {element.content}
                                                </LinkLien>
                                            </LinkLi>
                                        ))}
                                </LinkUl>
                            </LinkContainer>
                        )}

                        {/* Contenu multimédia */}
                        {hasMedia && (
                            <SectionContent>
                                {contentElements.map((element, idx) => (
                                    <React.Fragment key={idx}>
                                        {element.type === `${language}-text` && (
                                            <TextContainer>
                                                <StyledTexte>
                                                    {element.content}
                                                </StyledTexte>
                                            </TextContainer>
                                        )}

                                        {element.type === "image" && (
                                            <ProjectImgContainer>
                                                <ProjectImage
                                                    src={element.src}
                                                    alt={element.alt}
                                                />
                                            </ProjectImgContainer>
                                        )}

                                        {element.type === "video" && (
                                            <VideoContainer>
                                                <iframe
                                                    width="700px"
                                                    height="400px"
                                                    src={element.src}
                                                    title="Video"
                                                    frameBorder="0"
                                                    allowFullScreen
                                                ></iframe>
                                            </VideoContainer>
                                        )}
                                    </React.Fragment>
                                ))}
                            </SectionContent>
                        )}
                    </Section>
                );
            })}

            <BackButtton />
        </PageContainer>
    );
}

export default ProjectPage;
